import React, { useState, useEffect } from 'react';
import DashboardLayout from '../layout/DashboardLayout';
import '../../styles/StaffManagement.css';

const StaffManagement = () => {
  const [staff, setStaff] = useState([]);
  const [newStaff, setNewStaff] = useState({
    firstName: '',
    lastName: '',
    role: '',
    department: '',
    email: '',
    password: ''
  });
  const [successMsg, setSuccessMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const departments = [
    'Customer Service Department',
    'Medical Department',
    'Finance Department',
    'Human Resources Department'
  ];

  const roles = ['admin', 'staff'];

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const response = await fetch('https://clinic123.onrender.com/api/users', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      if (response.ok) {
        setStaff(data);
      }
    } catch (error) {
      console.error('Error fetching staff:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://clinic123.onrender.com/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(newStaff)
      });
      if (response.ok) {
        setNewStaff({ firstName: '', lastName: '', role: '', department: '', email: '', password: '' });
        fetchStaff();
        setSuccessMsg('✅ Staff member created successfully!');
        setTimeout(() => setSuccessMsg(''), 3000);
      }
    } catch (error) {
      console.error('Error adding staff:', error);
    }
  };

  const handleChange = (e) => {
    setNewStaff({
      ...newStaff,
      [e.target.name]: e.target.value
    });
  };

  const handleDelete = async (staffId) => {
    if (!window.confirm('Are you sure you want to delete this staff member?')) return;
    try {
      const response = await fetch(`https://clinic123.onrender.com/api/users/${staffId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        fetchStaff();
      }
    } catch (error) {
      console.error('Error deleting staff:', error);
    }
  };

  return (
    <DashboardLayout pageTitle="Staff Management">
      <div className="staff-management-container">
        {/* Add Staff Form */}
        <div className="card staff-card">
          <h3>Add New Staff</h3>
          {successMsg && <div className="success-message">{successMsg}</div>}
          <form onSubmit={handleSubmit} className="add-staff-form modern-staff-form">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="First Name"
                value={newStaff.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                value={newStaff.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="role">Role</label>
              <select
                id="role"
                name="role"
                value={newStaff.role}
                onChange={handleChange}
                required
              >
                <option value="">Select Role</option>
                {roles.map(role => (
                  <option key={role} value={role}>
                    {role.charAt(0).toUpperCase() + role.slice(1)}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="department">Department</label>
              <select
                id="department"
                name="department"
                value={newStaff.department}
                onChange={handleChange}
                required
              >
                <option value="">Select Department</option>
                {departments.map(dep => (
                  <option key={dep} value={dep}>
                    {dep}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email Address"
                value={newStaff.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password (min 8 chars, 1 uppercase, 1 number)"
                  value={newStaff.password}
                  onChange={handleChange}
                  required
                  style={{ flex: 1 }}
                />
                <span
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    fontSize: "1.2em"
                  }}
                  onClick={() => setShowPassword(prev => !prev)}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "👁️‍🗨️" : "👁️"}
                </span>
              </div>
            </div>
            <button type="submit" className="add-button modern-add-button">
              Add Staff
            </button>
          </form>
        </div>

        {/* Staff Table */}
        <div className="card staff-card">
          <h3>Current Staff</h3>
          <div className="staff-table-wrapper">
            <table className="staff-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Department</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {staff.map((member) => (
                  <tr key={member._id}>
                    <td>{member.firstName} {member.lastName}</td>
                    <td>{member.role}</td>
                    <td>{member.department}</td>
                    <td>{member.email}</td>
                    <td>
                      <button
                        onClick={() => handleDelete(member._id)}
                        className="delete-button"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {staff.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center' }}>
                      No staff members found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default StaffManagement;
